/* global google, markerClusterer */

// Libraries

var React = require('react');
var cloneDeep = require('lodash/cloneDeep');
var debounce = require('lodash/debounce');

// Refs

var MapElementRef = React.createRef();

// Components

var Icon = require('../../common/Icon/Icon.js');

const MemoMapElement = React.memo(function () {
	return (
		<div className="c-supporters-clubs-map__element" ref={MapElementRef}></div>
	);
});

// Styles

require('./SupportersClubsMapModule.scss');
var MapStyles = require('./SupportersClubsMapStyles.json');

class SupportersClubsMapModule extends React.Component {
	constructor(props) {

		super(props);

		this.mapInstance = null;
		this.placesAutocompleteService = null;
		this.geocoderServie = null;
		this.typingTimeout = null;
		this.mapContent = React.createRef();
		this.mapWrapper = React.createRef();
		this.mapMarkers = null;

		this.state = {
			clubs: this.getClubData(),
			searchTerm: '',
			searchResults: [],
			supplementaryResults: [],
			selectedClub: null,
			errorMinChar: false,
			errorNoResults: false,
			hideClubWebsiteAndEmail: true
		}

		if (typeof window === 'undefined') return;

		this.init();

	}

	getClubData() {

		if (!this.props.data.testMode) return this.props.data.clubs;

		let firstClubClone = cloneDeep(this.props.data.clubs[0]);

		const testClubs = [];

		this.props.data.testCoords.map((coords, index) => {

			let testClub = cloneDeep(firstClubClone);
			testClub.latitude = coords.latitude;
			testClub.longitude = coords.longitude;
			testClub.title = 'Test club ' + index;
			testClub.id = index;
			testClubs.push(testClub);

		})

		return testClubs;

	}

	init() {

		this.loadMapLibrary();

		const mapScriptLoadedInterval = setInterval(() => {

			if (
				window.supportersClubsMapScriptLoaded &&
				typeof markerClusterer === 'object'
			) {

				clearInterval(mapScriptLoadedInterval);
				this.renderMap();

			}

		}, 100);

	}

	loadMapLibrary() {

		const callbackScript = document.createElement('script');
		callbackScript.innerHTML = 'window.supportersClubsMapScriptLoaded = false; function supportersClubsMapScriptLoadedCallback() { window.supportersClubsMapScriptLoaded = true; }';
		document.body.appendChild(callbackScript);

		const mapScript = document.createElement('script');
		mapScript.src = 'https://maps.googleapis.com/maps/api/js?libraries=places&v=3.exp&key=' + this.props.data.mapKey + '&' + 'callback=supportersClubsMapScriptLoadedCallback';
		document.body.appendChild(mapScript);

		const staticFrontend = window['isStaticFrontEnd'] ? window['isStaticFrontEnd'] : false;

		const mapClusteringScript = document.createElement('script');
		mapClusteringScript.src = staticFrontend ? '/js/markerclusterer.min.js' : this.props.data.cdnUrl + '/static/js/_vanilla/markerclusterer.min.js';
		document.body.appendChild(mapClusteringScript);

	}

	renderMap() {

		const bounds = new google.maps.LatLngBounds();

		this.mapInstance = new google.maps.Map(MapElementRef.current, {
			zoom: 16,
			center: new google.maps.LatLng(51.604278, -0.066242),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			styles: MapStyles
		});

		const stadiumPosition = {
			lat: this.props.data.stadium.latitude,
			lng: this.props.data.stadium.longitude
		};

		const stadiumMarker = new google.maps.Marker({
			map: this.mapInstance,
			position: stadiumPosition,
			zIndex: 0,
			clickable: false,
			icon: {
				url: this.props.data.stadiumPinUrl,
				scaledSize: new google.maps.Size(53, 65),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(26, 60)
			}
		});

		bounds.extend(stadiumPosition);

		this.mapMarkers = this.state.clubs.map((club, i) => {

			const markerPosition = {
				lat: club.latitude,
				lng: club.longitude
			};

			const marker = new google.maps.Marker({
				map: this.mapInstance,
				position: markerPosition,
				icon: {
					url: this.props.data.clubPinUrl,
					scaledSize: new google.maps.Size(54, 63),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(27, 52)
				},
				id: club.id
			});

			marker.addListener('click', () => { this.handleResultClick(club.id, false); });

			bounds.extend(markerPosition);

			return marker;

		});

		const markerCluster = new markerClusterer.MarkerClusterer({
			markers: this.mapMarkers,
			map: this.mapInstance,
			renderer: {
				render: ({ count, position }) => new google.maps.Marker({
					label: {
						text: String(count),
						color: "#000A3C",
						fontSize: "15px",
						fontFamily: 'Outfit',
						fontWeight: '700'
					},
					icon: {
						url: this.props.data.clusterPinUrl,
						scaledSize: new google.maps.Size(52, 52),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(26, 26)
					},
					position,
					zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
				})
			}
		});

		this.mapInstance.fitBounds(bounds);

		this.placesAutocompleteService = new google.maps.places.AutocompleteService();
		this.geocoderService = new google.maps.Geocoder();

		this.sizeMap();
		window.addEventListener('resize', debounce(() => { this.sizeMap(); }, 250));
	}

	handleSearchTermChange(event, viaClick) {

		clearTimeout(this.typingTimeout);

		const fallbackValue = viaClick ? this.state.searchTerm : '';
		const value = (event && event.target && event.target.value) ? event.target.value : fallbackValue;

		this.setState({
			searchTerm: value,
			searchResults: [],
			supplementaryResults: [],
			selectedClub: null,
			errorMinChar: false,
			errorNoResults: false
		});

		if (value.length < 3) {

			if (viaClick) {

				this.setState({
					errorMinChar: true
				});

			}

			this.sizeMap();
			return;

		};

		this.typingTimeout = setTimeout(() => {

			const clonedClubs = cloneDeep(this.state.clubs);
			const matchingClubs = clonedClubs.filter(club => club.title.toLowerCase().match(value.toLowerCase()) !== null);

			this.setState({ searchResults: matchingClubs });

			this.placesAutocompleteService.getPlacePredictions({
				input: value,
				types: ['geocode']
			}, (predictions, status) => {

				const noResults = (status == google.maps.places.PlacesServiceStatus.ZERO_RESULTS);
				const ok = (status == google.maps.places.PlacesServiceStatus.OK);

				if (
					!ok &&
					!noResults
				) {

					console.log('Error with places autocomplete service');
					return;

				}

				this.setState({
					supplementaryResults: !noResults ? predictions : [],
					errorNoResults: noResults && !matchingClubs.length
				});

			});

		}, 500);

	}

	handleSearchClick() {

		this.handleSearchTermChange(null, true);

	}

	handleClearClick() {

		clearTimeout(this.typingTimeout);

		this.setState({
			searchTerm: '',
			searchResults: [],
			supplementaryResults: [],
			selectedClub: null,
			errorMinChar: false,
			errorNoResults: false
		});

		this.mapMarkers.map((marker, i) => { marker.setAnimation(null); });
		setTimeout(() => { this.sizeMap(); }, 100);
	}

	handleResultClick(id, focusOnPin) {

		const clonedClubs = cloneDeep(this.state.clubs);
		const matchingClubs = clonedClubs.filter(club => club.id === id);

		if (!matchingClubs.length) {

			alert('Sorry! We could not find information about that club.');
			return;

		}

		if (focusOnPin) {

			this.mapInstance.setZoom(16);
			this.mapInstance.panTo({
				lat: matchingClubs[0].latitude,
				lng: matchingClubs[0].longitude
			});

		}

		this.handleClearClick();

		const matchingMarkers = this.mapMarkers.filter(marker => marker.id === id);
		if (matchingMarkers.length) matchingMarkers[0].setAnimation(google.maps.Animation.BOUNCE);

		this.setState({ selectedClub: matchingClubs[0] });
		setTimeout(() => { this.sizeMap(); }, 100);
	}

	handleSupplementaryResultClick(place_id) {

		this.geocoderService.geocode({ placeId: place_id }).then((response) => {

			if (
				!response.results ||
				!response.results.length
			) {

				console.log('Error with geocoding service');
				return;

			}

			const lat = response.results[0].geometry.location.lat();
			const lng = response.results[0].geometry.location.lng();

			this.mapInstance.setZoom(9);
			this.mapInstance.panTo({
				lat: lat,
				lng: lng
			});

		});

	}

	formatUrlForDisplay(url) {

		url = url.replace('www.', '');
		url = url.replace('http://', '');
		url = url.replace('https://', '');
		return url;

	}

	sizeMap() {

		this.mapWrapper.current.removeAttribute('style');
		MapElementRef.current.removeAttribute('style');

		if (matchMedia('(min-width: 1000px)').matches) return;

		const mapContentHeight = this.mapContent.current.offsetHeight;
		const subNavigationHeight = document.querySelector('.SubNavigation').offsetHeight;

		this.mapWrapper.current.style.paddingTop = (mapContentHeight) + 'px';
		MapElementRef.current.style.height = 'calc(100dvh - ' + (mapContentHeight + subNavigationHeight) + 'px)';

	}

	render() {
		const searchTextId = 'supporters-clubs-search';
		return (
			<div className="c-supporters-clubs-map" id={this.props.data.id} ref={this.mapWrapper}>

				<MemoMapElement />

				<div className="c-supporters-clubs-map__content" ref={this.mapContent}>
					<div className="c-supporters-clubs-map__content__controls">
						<div className="c-supporters-clubs-map__content__controls__search">
							<label htmlFor={searchTextId} className="u-visually-hidden">Search for a supporters club</label>
							<input id={searchTextId} className="c-supporters-clubs-map__content__controls__search__text" type="text" name={searchTextId} placeholder="Search for a club..." value={this.state.searchTerm} onChange={this.handleSearchTermChange.bind(this)} />
							<button type="button" className="c-supporters-clubs-map__content__controls__search__button" onClick={this.handleSearchClick.bind(this)}>
								<Icon className="c-supporters-clubs-map__content__controls__search__button__icon" name="search" width="22" height="24" />
								<span className="u-visually-hidden">Search for a supporters club</span>
							</button>
						</div>
						<button type="button" className="c-supporters-clubs-map__content__controls__clear" onClick={this.handleClearClick.bind(this)}>
							<Icon className="c-supporters-clubs-map__content__controls__clear__icon" name="close" width="30" height="30" />
							<span className="u-visually-hidden">Clear supporters club search</span>
						</button>
					</div>
					<div className="c-supporters-clubs-map__content__search-results-container">
						{this.state.searchResults.length > 0 &&
							<ul className="c-supporters-clubs-map__content__search-results c-supporters-clubs-map__content__search-results--established">
								{this.state.searchResults.map((searchResult, index) => {
									return (
										<li key={index} className="c-supporters-clubs-map__content__search-results__item">
											<button type="button" onClick={this.handleResultClick.bind(this, searchResult.id, true)} className="c-supporters-clubs-map__content__search-results__item__button">
												<Icon className="c-supporters-clubs-map__content__search-results__item__button__icon" name="logoNoText" width="15" height="37" />
												{searchResult.title}
											</button>
										</li>
									)
								})}
							</ul>
						}
						{this.state.supplementaryResults.length > 0 &&
							<ul className="c-supporters-clubs-map__content__search-results c-supporters-clubs-map__content__search-results--supplementary">
								{this.state.supplementaryResults.map((supplementaryResult, index) => {
									return (
										<li key={index} className="c-supporters-clubs-map__content__search-results__item">
											<button type="button" onClick={this.handleSupplementaryResultClick.bind(this, supplementaryResult.place_id)} className="c-supporters-clubs-map__content__search-results__item__button">
												<Icon className="c-supporters-clubs-map__content__search-results__item__button__icon" name="location" width="15" height="23" />
												{supplementaryResult.description}
											</button>
										</li>
									)
								})}
							</ul>
						}
						{this.state.errorMinChar &&
							<p className="c-supporters-clubs-map__content__search-error" role="alert">Please enter at least 3 characters to search for a supporters club.</p>
						}
						{this.state.errorNoResults &&
							<p className="c-supporters-clubs-map__content__search-error" role="alert">Sorry!  No results were found for "{this.state.searchTerm}" when searching for a supporters club.</p>
						}
						{this.state.selectedClub &&
							<div className="c-supporters-clubs-map__content__club">
								{(this.state.selectedClub.title && this.state.selectedClub.title !== '') &&
									<p className="c-supporters-clubs-map__content__club__name">
										<Icon className="c-supporters-clubs-map__content__club__name__icon" name="location" width="15" height="23" />
										{this.state.selectedClub.title}
									</p>
								}
								{((this.state.selectedClub.website && this.state.selectedClub.website !== '') || (this.state.selectedClub.email && this.state.selectedClub.email !== '')) && !this.state.hideClubWebsiteAndEmail &&
									<ul className="c-supporters-clubs-map__content__club__list">
										{(this.state.selectedClub.website && this.state.selectedClub.website !== '') &&
											<li className="c-supporters-clubs-map__content__club__list__item">
												<a href={this.state.selectedClub.website} className="c-supporters-clubs-map__content__club__list__item__link" target="_blank" rel="noopener noreferrer external">
													{this.formatUrlForDisplay(this.state.selectedClub.website)}
												</a>
											</li>
										}
										{(this.state.selectedClub.email && this.state.selectedClub.email !== '') &&
											<li className="c-supporters-clubs-map__content__club__list__item">
												<a href={`mailto:${this.state.selectedClub.email}`} className="c-supporters-clubs-map__content__club__list__item__link">
													{this.state.selectedClub.email}
												</a>
											</li>
										}
									</ul>
								}
								{(this.state.selectedClub.url && this.state.selectedClub.url !== '') &&
									<p className="c-supporters-clubs-map__content__club__link">
										<a className="c-button c-button--small" href={this.state.selectedClub.url}>Club details</a>
									</p>
								}
							</div>
						}
					</div>
					<div className="c-supporters-clubs-map__content__footer">
						<p className="c-supporters-clubs-map__content__footer__tagline">
							<span className="c-supporters-clubs-map__content__footer__tagline__inner">
								Can't find a club?<span className="c-supporters-clubs-map__content__footer__tagline__inner__suffix"> Start one!</span>
							</span>
						</p>
						<a href="https://www.tottenhamhotspur.com/fans/supporters-clubs/form-a-club/" className="c-button c-button--small c-supporters-clubs-map__content__footer__cta">Form a club</a>
					</div>
				</div>

			</div>
		);
	}

};

module.exports = SupportersClubsMapModule;



// WEBPACK FOOTER //
// ./src/components/SupportersClubsMap/SupportersClubsMapModule.js